import {
  GetString,
} from 'fluent-react';
import React from 'react';
import styled from 'styled-components';
import { getLinearScale } from '../../NonConstantUtils';
import { formatECI } from '../../numberFormatters';
import {
  primaryColor1,
} from '../Utils';
import Gradient from './Gradient';

//#region Styling
const Container = styled.div`
  width: 350px;
  height: 100%;
  display: grid;
  grid-template-rows: 1fr 10px 1fr;
  margin: 0 auto;
`;
const ExtremesContainer = styled.div`
  grid-row: 1 / 2;
  grid-column: 1 / 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.75rem;
  color: rgb(102, 102, 102);
`;
const EciLabelContainer = styled.div`
  grid-row: 3 / 4;
  grid-column: 1 / 2;
  position: relative;
`;
const EciLabel = styled.div`
  position: absolute;
  bottom: 0;
  font-size: 0.75rem;
  color: ${primaryColor1};
  white-space: nowrap;
`;
const EciTickContainer = styled.div`
  grid-row: 2 / 4;
  grid-column: 1 / 2;
  position: relative;
`;
const EciTick = styled.div`
  position: absolute;
  bottom: 0;
  top: 0;
  width: 1px;
  background-color: ${primaryColor1};
  opacity: 0.6;
`;
//#endregion

interface Props {
  getFluentString: GetString;
  min: number;
  max: number;
  eci: number | null;
}

export default (props: Props) => {
  const {
    getFluentString, min, max, eci,
  } = props;

  const upperBoundLabel = getFluentString('tree-map-eci-color-legend-upper-bound-label');
  const lowerBoundLabel = getFluentString('tree-map-eci-color-legend-lower-bound-label');
  const scale = getLinearScale([min, max], [0, 100]);
  let eciOutput: React.ReactElement<any> | null;
  if (eci === null) {
    eciOutput = null;
  } else {
    const xCoordOfECILabel = scale(eci);
    const eciLabelStyle: React.CSSProperties = {
      left: `calc(${xCoordOfECILabel}% + 10px)`,
    };
    const eciLabel = getFluentString('tree-map-eci-color-legend-eci-label', {
      quantity: formatECI(eci),
    });
    const eciTickStyle: React.CSSProperties = {
      left: `${xCoordOfECILabel}%`,
    };
    eciOutput = (
      <>
        <EciLabelContainer>
          <EciLabel style={eciLabelStyle}>{eciLabel}</EciLabel>
        </EciLabelContainer>
        <EciTickContainer>
          <EciTick style={eciTickStyle}/>
        </EciTickContainer>
      </>
    );
  }
  return (
      <Container>
        <ExtremesContainer>
          <div>{lowerBoundLabel}</div>
          <div>{upperBoundLabel}</div>
        </ExtremesContainer>
        <Gradient/>
        {eciOutput}
      </Container>
  );
};
